<template>
	<div class="pagesContent">
		<el-card class='mb-20'>
			<div style="display: flex;justify-content: space-between;align-items: center;">
				<h4><i class="el-icon-notebook-2"></i> 权限设置</h4>
				<div>
					<el-button type="primary" size="medium" icon="el-icon-plus" @click="drawer = true">
						添加权限
					</el-button>
					<el-button type="primary" size="medium" icon="el-icon-plus" @click="powerDialog = true">
						添加角色
					</el-button>
				</div>
			</div>
		</el-card>
		<!-- 添加权限 -->
		<el-card class="card-box section" style="margin-top: 10px;">
			<el-table size="mini" max-height="500" :data="permission" stripe border style="width: 100%">
				<el-table-column prop="Name" label="角色名称" align="center" min-width="80"></el-table-column>
				<el-table-column prop="Description" label="角色描述" align="center" min-width="150">
				</el-table-column>
				<el-table-column prop="CreateTime" label="创建时间" align="center" min-width="90">
					<template slot-scope="{row}">
						{{row.CreateTime | dateYMDFormat}}
					</template>
				</el-table-column>
				<el-table-column label="操作" align="center" width="150">
					<template slot-scope="scope">
						<el-button type="primary" size="mini" @click="uploadRole(scope.row)">修改</el-button>
						<el-button type="danger" size="mini" @click="removeRole(scope.row,scope.$index)">删除</el-button>
					</template>
				</el-table-column>
			</el-table>
		</el-card>
		<!-- 添加角色 -->
		<el-dialog title="新增角色" :visible.sync="powerDialog" width="30%" center @close="diglogClose">
			<el-form label-width="85px" :model="roleData">
				<el-form-item label="角色名称：">
					<el-input placeholder="请输入角色名称" size="mini" v-model="roleData.Name"></el-input>
				</el-form-item>
				<el-form-item label="角色描述：">
					<el-input placeholder='请输入角色描述' type="textarea" :rows="2" v-model="roleData.Description"></el-input>
				</el-form-item>
				<el-form-item label="权限选择：">
					<el-tree :data="datas" :props="defaultProps" ref='tree' :default-expand-all='true' node-key="Code" :default-checked-keys='addRoleIdList' show-checkbox>
					</el-tree>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="addRoleIdList = []">取 消</el-button>
				<el-button type="primary" @click="addRole">确 定</el-button>
			</span>
		</el-dialog>
		<!-- 权限 -->
		<el-drawer :visible.sync="drawer" size="50%" :with-header="false" :before-close="handleClose">
			<div style="padding: 10px;">
				<div style="display: flex;justify-content: flex-end;margin-bottom: 10px;">
					<el-button type="primary" @click="setRole(0)">添加权限</el-button>
				</div>
				<el-tree :data="datas" :props="defaultProps" node-key="Code" default-expand-all :expand-on-click-node="false">
					<span class="custom-tree-node" slot-scope="{ node, data }">
						<span>{{ node.data.Name }}</span>
						<span>
							<el-button type="text" size="mini" @click="() => setRole(1,data)">
								添加
							</el-button>
						</span>
					</span>
				</el-tree>
			</div>

		</el-drawer>

		<!-- 添加权限 -->
		<el-dialog title="添加权限" :visible.sync="permissionSet" width="30%" center @close="diglogClose">
			<el-form label-width="85px" :model="addMenu">
				<el-form-item label="唯一编码：">
					<el-input placeholder="请输入唯一编码" size="mini" v-model="addMenu.Code"></el-input>
				</el-form-item>
				<el-form-item label="名称：">
					<el-input placeholder='请输入名称' size="mini" v-model="addMenu.Name"></el-input>
				</el-form-item>
				<el-form-item label="描述：">
					<el-input placeholder='请输入描述' type="textarea" :rows="2" v-model="addMenu.Description"></el-input>
				</el-form-item>
			</el-form>
			<span slot="footer" class="dialog-footer">
				<el-button @click="permissionSet = false">取 消</el-button>
				<el-button type="primary" @click="addMenuAcion">确 定</el-button>
			</span>
		</el-dialog>

	</div>
</template>
<script>
	export default {
		data() {
			return {
				// 权限抽屉
				drawer: false,
				// 添加权限对话框
				permissionSet: false,
				// 要添加权限的菜单
				addMenu: {
					Code: '', //唯一编码
					Name: '', //名称
					Description: '', //描述
					ParentCode: '' //属于那个菜单或操作
				},
				// 权限
				permission: [],
				powerDialog: false,
				roleData: {
					Name: '',
					Description: '',
					RolePermissions: []
				},
				// 权限树显示内容
				defaultProps: {
					children: 'RolePermissions',
					label: 'Name'
				},
				// 权限列表
				datas: [],
				// 当前被选中的权限
				interim: {},
				roleNum: 0,
				// 待添加的权限列表
				addRoleList:[],
				// 所有默认被选中的id
				addRoleIdList:[],
			}
		},
		mounted() {
			var arr = [1,2,3]
			for(var i=arr.length;arr>0;i--){
				console.log(i);
			}
			this.getAllPower()
			this.getAllRole()
		},
		methods: {
			// 查询所有角色
			getAllRole() {
				this.$http.getAllRole().then(res => {
					// console.log(res.data)
					if (res.status == 200) {
						this.permission = res.data
					}
				})
			},
			// 获取所有权限
			getAllPower() {
				this.$http.getAllMenuAction().then(res => {
					this.roleNum = res.data.length;
					this.datas = this.getObjectDeep(res.data, '', []);
					console.log(this.datas);
				})
			},
			// 修改角色
			uploadRole(row) {
				this.addRoleIdList = []
				this.addRoleIdList = row.RolePermissions.map(v=>{
					return v.MenuActionCode
				})
				this.roleData = row
				this.powerDialog = true
			},
			// 删除角色
			removeRole(row, ind) {
				console.log(row)
				let dat = `?roleId=${row.Id}`
				this.$http.delRoleMsg(dat).then(res => {
					console.log(res)
					if (res.status == 200) {
						if (res.data.Code == 200) {
							this.permission.splice(ind, 1)
							this.$message.success('删除成功')
						}
					}
				})
			},
			// 添加角色
			addRole() {
				if (this.roleData.Id) {
					var data = `?roleName=${this.roleData.Name}&roleId=${this.roleData.Id}`
				} else {
					var data = `?roleName=${this.roleData.Name}`
				}
				this.$http.judRoleName(data).then(res => {
					console.log(res)
					if (res.status == 200) {
						if (res.data) {
							this.$message('该角色名字已存在')
						} else {
							var role = Object.assign({},this.roleData)
							role.RolePermissions = this.$refs.tree.getCheckedKeys().map(v=>{
								return {
									RoleId: this.roleData?.Id || 0,
									MenuActionCode: v
								}
							});
							console.log(role);
							this.$http.setRole(role).then(rs => {
								console.log(rs)
								if (rs.status == 200) {
									if (rs.data.Code == 200) {
										this.getAllRole()
										this.$message.success('添加成功')
										this.powerDialog = false
									}
								}
							})
						}
					}
				})
			},
			// 打开编辑/添加权限弹出层
			setRole(type,data){
				// 添加第一次权限
				if(type==0){
					this.addMenu.Code = `${(this.roleNum + 1)}`;
				}else if(type==1){// 添加子权限
					this.addMenu.ParentCode = data.Code;
					this.addMenu.Code = `${(this.roleNum + 1)}`;
				}else{// 编辑子权限
					this.addMenu = data;
				}
				this.permissionSet = true;
			},
			// 添加第一层权限，添加前需验证编码的唯一性
			addMenuAcion() {
				let code = `?code=${this.addMenu.Code}`
				this.$http.getMenuCode(code).then(res => {
					if (res.status == 200) {
						if (res.data) {
							this.$message('该唯一编码已存在请更换')
						} else {
							this.$http.addAllpower(this.addMenu).then(val => {
								if (val.status == 200) {
									if (val.data.Code == 200) {
										this.getAllPower()
										this.$message.success('添加成功')
										this.permissionSet = false
									}
								}
							})
						}
					}
				})
			},
			// g关闭弹出层
			diglogClose() {
				this.addRoleIdList = []	
				console.log(this.addRoleIdList);
				// 关闭时重置所有菜单
				this.addMenu = this.$options.data.call(this).addMenu
				this.interim = this.$options.data.call(this).interim
				this.roleData = this.$options.data.call(this).roleData
				this.$nextTick(()=>{})
			},
			handleClose(done) {
				done();
			},
			// 递归调用
			getObjectDeep(list, pCode) {
				// 返回权限信息
				return list.filter(v=>{
					// 筛选出父标识相同的
					if(v.ParentCode == pCode){
						// 筛选出他的子权限
						v.RolePermissions = this.getObjectDeep(list,v.Code)
						// 返回该项
						return v
					}
					// 没有不返回
					return false
				})
				// //获取所有一级
				// for (let item of list) {
				// 	if (item.ParentCode == pCode) {
				// 		data.push(item);
				// 	}
				// }
				// //获取子级
				// for (let i of data) {
				// 	this.getObjectDeep(list, i.Code, i.RolePermissions); //递归调用
				// }
				// return data
			},
		}
	}
</script>
<style>
	.mb-20 {
		margin-bottom: 20px;
	}

	.custom-tree-node {
		flex: 1;
		display: flex;
		align-items: center;
		justify-content: space-between;
		font-size: 14px;
		padding-right: 8px;
	}
</style>
